import React, { useState } from "react";
import Card from "../Card";
import Spacing from "../Spacing";
import Grid from "../Grid";
import BorderCard from "../Card/BorderCard";
import { numberWithCommas, role_has } from "../../helpers";
import { caregap_name } from "../../helpers";
import Skeleton from "react-loading-skeleton";

export default function GapsInCare({ GapsInCareStatus, audit=false }) {
  const [isReporting, setIsReporting] = useState(1);
  const [maxCaregapsId, setMaxCaregapsId] = useState(role_has("Enterprise") ? 1000 : 15);

  return (
    <Card>
      <div className="flex justify-between">
        <h2 className="docpro_fs_20 docpro_mb_0">Gaps In Care </h2>
        {/* <div className="docpro_tab_btns_2">
          <button
            type="button"
            className={`${isReporting === 1 ? "active" : ""}`}
            onClick={() => setIsReporting(1)}
          >
            Pending
          </button>
          <button
            type="button"
            className={`${isReporting === 2 ? "active" : ""}`}
            onClick={() => setIsReporting(2)}
          >
            Done
          </button>
        </div> */}
      </div>
      <Spacing lg="15" sm="15" />

      <Grid variant={`docpro_grid_gap_4 ${audit ? 'docpro_grid_col_3' : 'docpro_grid_col_4'}`}>
        {GapsInCareStatus?.length > 0 ? (
          GapsInCareStatus?.map((item, index) =>
            ![10, 12].includes(item.care_gap_id) && maxCaregapsId >= item.care_gap_id && 
            // item.total > 0 &&
            // !isNaN(item.total) && ( // Skip if total is 0 or NaN
              <BorderCard
                key={index}
                icon={item?.care_gap_id}
                title={caregap_name(item?.care_gap_id)}
                donePercentage={
                  isNaN(((item?.total - item?.pending) / item?.total) * 100) ? 
                  0 : (
                    ((item?.total - item?.pending) / item?.total) * 100
                  ).toFixed(2)
                }
                pendingPercentage={
                  isNaN((item?.pending / item?.total) * 100) ? 
                  0 : (
                    (item?.pending / item?.total) * 100
                  ).toFixed(2)
                }
                numberOfDoneItem={
                  `${numberWithCommas(item?.total - item?.pending)}/${numberWithCommas(item?.total)}`
                }
                numberOfPendingItem={
                  `${numberWithCommas(item?.pending)}/${numberWithCommas(item?.total)}`
                }
                doneItem={
                  `${numberWithCommas(item?.total - item?.pending)}`
                }
                pendingItem={
                  `${numberWithCommas(item?.pending || 0)}`
                }
                completed={item?.completed}
                queryParamsId={item?.care_gap_id}
                isReporting={isReporting}
                setIsReporting={setIsReporting}
              />
            // )
          )
        ) : (
          Array.from({ length: 10 }, (_, i) => (
            <Skeleton key={i} width="100%" height="7rem" borderRadius="12px" />
          ))
        )}
      </Grid>
    </Card>
  );
}
